import { V1_REQUEST_AIRPORTS } from '../../actions/airports/v1requestAirports'
import { V1_RECEIVE_AIRPORTS } from '../../actions/airports/v1receiveAirports'

const initialState = {
  isFetching: false,
  items: [],
}

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case V1_REQUEST_AIRPORTS:
      return {
        ...state,
        isFetching: true,
      }
    case V1_RECEIVE_AIRPORTS:
      return {
        ...state,
        isFetching: false,
        items: action.data,
      }
    default:
      return state
  }
}
